import { ReactNode, useEffect, useState } from "react";
import { ToastWrapper } from "./atom";
import SuccessIcon from "./icons/success";
import ErrorIcon from "./icons/error";
import InfoIcon from "./icons/info";
import ProcessingIcon from "./icons/processing";
import { IToastState } from "@/store2/toast/type";

export function Toast({
  type = ToastType.success,
  show = false,
  top = "10vh",
  duration = 1500,
  content,
  setShow,
}: ToastProps) {
  const Icon = {
    [ToastType.success]: SuccessIcon,
    [ToastType.error]: ErrorIcon,
    [ToastType.info]: InfoIcon,
    [ToastType.processing]: ProcessingIcon,
  }[type];

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow && setShow({ show: false });
    }, duration);
    return () => {
      window.clearTimeout(timer);
    };
  }, [show]);
  return (
    <ToastWrapper top={top} show={show}>
      <Icon />
      {content}
    </ToastWrapper>
  );
}

export enum ToastType {
  success = "success",
  error = "error",
  info = "info",
  processing = "processing",
}

export type ToastProps = {
  type?: `${ToastType}`;
  show?: boolean;
  content?: ReactNode;
  top?: string;
  duration?: number;
  setShow?: (show: IToastState) => void;
};
